import { dayKey } from './time.ts';

const DAY_MS = 86_400_000;

/**
 * Which of the week's meetings the Meetings page's Coming up card shows.
 *
 * Vladimir, 2026-09-21: *"show only today's meetings in the future if needed,
 * and if it's less than 3 left - show today's and tomorrow's, not more"* — the
 * page is for finding notes, and a week of calendar buried them.
 *
 * ⚠ And, 2026-09-26: *"This is a lie, I have a lot of meetings in the next 7
 * days, just no meetings today and tmr"*. With nothing today or tomorrow — a
 * weekend — the card said the whole week was empty. So the next day that has
 * any takes their place: still one day, still small.
 */
export function comingUp<T extends { startsAt: string }>(rows: T[], now = new Date()): T[] {
  const on = (key: string) => rows.filter((e) => dayKey(e.startsAt) === key);
  const today = on(dayKey(now.toISOString()));
  if (today.length >= 3) return today;
  const both = [...today, ...on(dayKey(new Date(now.getTime() + DAY_MS).toISOString()))];
  if (both.length > 0) return both;
  const next = rows.find((e) => Date.parse(e.startsAt) > now.getTime());
  return next ? on(dayKey(next.startsAt)) : [];
}
